import {bankCardReg, nameReg, IDcardReg, phoneReg} from '@/utils/regular.js'
import { statisticsConfig } from '@/utils/statisticsConfig'

export const regular = {
    'name':(str) => {return nameReg.test(str)},
    'id':(str) => {
      if(new RegExp("[*]").test(str)){
        return true
      }else{
        return IDcardReg(str)
      }
    } ,
    'phone':(str) => {
      if(new RegExp("[*]").test(str)){
        return true
      }else{
        return phoneReg.test(str)
      }
    },
    'bank':(str) => {return bankCardReg.test(str)} 
}


export const infoMyFrom = [
    {
      title:'姓名',
      // placeholder:'请填写您的姓名',
      verify:{valid:false},
      name:'name',
      type:'name',
      disabled:true,
      statistic:()=>{
        statisticsConfig.insur_insurinfoinput_holdername_click()
      }
    },
    {
      title:'身份证号',
      // placeholder:'请填写您的身份证号',
      verify:{valid:false},
      name:'idcard',
      type:'id',
      disabled:true,
      statistic:()=>{
        statisticsConfig.insur_insurinfoinput_holderidentity_click()
      }

    },
    {
      title:'手机号码',
      // placeholder:'请填写您的手机号码',
      verify:{valid:false},
      name:'phone',
      type:'phone',
      disabled:true,
      statistic:()=>{
        statisticsConfig.insur_insurinfoinput_holderphone_click()
      }

    },
]

export const infoOtherFrom = [
    {
      title:'姓名',
      placeholder:'请填写TA的姓名',
      verify:{valid:false},
      name:'name',
      type:'name',
      disabled:true,
      statistic:()=>{
        statisticsConfig.insur_insurinfoinput_insuredname_click()
      }
    },
    {
      title:'身份证号',
      placeholder:'请填写TA的身份证号',
      verify:{valid:false},
      name:'idcard',
      type:'id',
      disabled:true,
      statistic:()=>{
        statisticsConfig.insur_insurinfoinput_insuredidentity_click()
      }
    }
]

export const tabList = [
    {name:'本人',selected:true,statistic:()=>{statisticsConfig.insur_insurinfoinput_holderself_click()}},
    {name:'子女',selected:false,statistic:()=>{statisticsConfig.insur_insurinfoinput_holderchild_click()}},
    {name:'配偶',selected:false,statistic:()=>{statisticsConfig.insur_insurinfoinput_holdermate_click()}},
    {name:'父母',selected:false,statistic:()=>{statisticsConfig.insur_insurinfoinput_holderparent_click()}},
]


export const tabTypeList = [
    // {name:'按月缴费',selected:true,statistic:()=>{statisticsConfig.insur_insurinfoinput_paymonth_click()}},
    {name:'一次缴清',selected:true,statistic:()=>{statisticsConfig.insur_insurinfoinput_payyear_click()}},
]
